export default {
  // 企業情報
  PAGE_TITLE: "公司資訊",
  COMPANY_INFO: "公司資訊",
};
